import styled from 'styled-components'

import { helpers } from 'styles'

export const Title = styled.span`
	font-family: ${helpers.font.family.code};
	text-transform: uppercase;
	font-weight: 400;
	margin: 0 0 6px 4px;
	display: block;
`
